module.exports = __webpack_public_path__ + "static/img/Siosifa-Talakai.75f3b2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Siosifa-Talakai.jpg
// module id = gdWl
// module chunks = 0